import React, { useState } from 'react'
import CommonView from '../CommonView'
import { createCity as createCityGraphQL } from '../../../../../Module/graphQL'
import { authorization } from '../../../../../Module/Auth/Auth'
import { DEFAULT_DATA } from '../util/constants'

export const CreateCityView = props => {
  var [isSaving, setIsSaving] = useState(false)
  const createCity = async data => {
    setIsSaving(true)
    data = {
      ...data,
      location: data.cityLocation,
    }
    delete data.cityLocation
    var response = await createCityGraphQL(authorization.getAPIKey(), data)
    var result = await response.json()
    if (result['errorMessage']) return alert(result['errorMessage'])
    if (result.errors && result.errors[0])
      return alert(new Error(result.errors[0].message))
    setIsSaving(false)

    props.history.push(
      `/dashboard/cities/${result.data.createCity.city.id}/edit`,
    )
  }

  return (
    <CommonView
      isCreate={true}
      isSaving={isSaving}
      updateCity={createCity}
      isLoaded={true}
      enableEditCountry={true}
      enableChangeTimezone={true}
      // Defaults
      surgeInterval={15}
      newcomersMissionsLimit={3}
      status="ACTIVE"
      morningCheckInTime="07:30:00"
      lunchCheckInTime="11:00:00"
      afternoonCheckInTime="14:00:00"
      h2hCheckInTimeBefore={DEFAULT_DATA.h2hCheckInTimeBefore}
      h2hCheckInTimeAfter={DEFAULT_DATA.h2hCheckInTimeAfter}
      d2dCheckInTimeBefore={DEFAULT_DATA.d2dCheckInTimeBefore}
      d2dCheckInTimeAfter={DEFAULT_DATA.d2dCheckInTimeAfter}
      h2hBonusCheckInTimeBefore={DEFAULT_DATA.h2hBonusCheckInTimeBefore}
      h2hBonusCheckInTimeAfter={DEFAULT_DATA.h2hBonusCheckInTimeAfter}
      d2dBonusCheckInTimeBefore={DEFAULT_DATA.d2dBonusCheckInTimeBefore}
      d2dBonusCheckInTimeAfter={DEFAULT_DATA.d2dBonusCheckInTimeAfter}
      {...props}
    />
  )
}
